<template>
  <div class="judgetrue">
    <div class="judgetrue-warpper">
      <h1>填写信息</h1>
      <h3>
        <!-- <span @click="to_tipresult">举报奖励</span> -->
      </h3>
      <div class="form-item">
        <span>{{ pageConfig.phoneTitle || '联系电话' }}</span>
        <input type="text" />
      </div>
      <div class="form-item">
        <span>{{ pageConfig.addressTitle || '购买地址' }}</span>
        <input type="text" />
      </div>
      <div class="form-item">
        <span>{{ pageConfig.productTitle || '购买商店' }}</span>
        <input type="text" />
      </div>
      <div class="form-item">
        <span>上传照片</span>
        <div class="photo">
          <div class="explain">
            <span @click="explain">(拍摄说明)</span>
          </div>
          <div class="pic-warpper">
            <div>
              <img src="../../assets/images/photo.jpg" alt />
            </div>
            <div>
              <img src="../../assets/images/photo.jpg" alt />
            </div>
            <div>
              <img src="../../assets/images/photo.jpg" alt />
            </div>
            <div>
              <img src="../../assets/images/photo.jpg" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="form-item2">
        <span>简要说明</span>
        <textarea></textarea>
      </div>
    </div>
    <div class="footer">
      <span class="btn" @click="search">提 交</span>
    </div>
  </div>
</template>

<script>
import { listH5Pages } from '@/api/h5Pages'
export default {
  data () {
    return {
      pageConfig: {}
    }
  },
  created () {
    listH5Pages({ appletId: this.$route.query.appletId }).then(res => {
      console.log(res.data)
      let _obj = res.data.find(item => item.pageType == 9)
      if (_obj) {
        this.pageConfig = JSON.parse(_obj.links)[0]
        console.log(this.pageConfig)
      }
    })
  },
  methods: {
    search: function () {
      this.$router.push("/callback");
    },
    to_tipresult: function () {
      this.$router.push("/tipresult");
    },
    explain: function () {
      this.$router.push({ path: "/main", query: { pageId: this.pageConfig.value } });
    }
  }
}
</script>

<style  lang="scss" scoped>
.judgetrue {
  color: #231815;
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  overflow: auto;

  .judgetrue-warpper {
    box-sizing: border-box;
    padding: 1.027778rem;
    min-height: 100%;
    //margin-bottom: 0.833333rem;

    h1 {
      line-height: 1.333333rem;
      font-size: 0.666667rem;
      color: #3E3A39;
      text-align: center;
    }

    h3 {
      font-size: 0.416667rem;
      font-weight: 400;
      color: #1B92D2;
      line-height: 0.972222rem;
      text-align: center;

      span {
        padding: 0.083333rem;
        border-bottom: 1px solid #1B92D2;
      }
    }

    .form-item2 {
      margin: 0.777778rem auto;

      span {
        text-align: right;
        font-size: 0.444444rem;
        padding-right: 0.138889rem;
        box-sizing: border-box;
        line-height: 0.833333rem;
        width: 1.944444rem;
        display: inline-block;
      }

      textarea {
        width: calc(100% - 0.277778rem);
        border: none;
        margin: 0 0.138889rem;
        height: 2.222222rem;
      }
    }

    .form-item {
      display: flex;
      margin: 0.777778rem auto;

      span {
        flex: 0 1.944444rem;
        text-align: right;
        padding-right: 0.138889rem;
        box-sizing: border-box;
        line-height: 0.833333rem;
        font-size: 0.444444rem;
      }

      .photo-label {
        flex: 0 4.166667rem;
        padding: 0.083333rem;
        border-bottom: 1px solid #1B92D2;
      }

      input {
        flex: 1;
        width: 100%;
        border: none;
        height: 0.833333rem;
      }
    }

    .photo {
      flex: 1;

      .pic-warpper {
        display: flex;

        div {
          flex: 1;
          box-sizing: border-box;
          padding: 5px;

          img {
            width: 100%;
          }
        }
      }

      .explain {
        font-size: 0.416667rem;
        font-weight: 400;
        color: #1b92d2;
        line-height: 0.972222rem;

        span {
          padding: 0.083333rem 0;
          border-bottom: 1px solid #1b92d2;
        }
      }
    }
  }

  .footer {
    width: 100%;
    text-align: center;
    margin-top: -1.666667rem;

    .btn {
      font-size: 0.5rem;
      color: #009fe8;
      border-bottom: 1px solid #009fe8;
      padding: 3px 0.138889rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/example01/tip.vue